module.exports = __webpack_public_path__ + "img/6.7aecb508.jpg";